/**
 * Created by IntelliJ IDEA.
 * User: jv
 * Date: 12/05/16
 * Time: 12:56
 */
const utils = require("Sources/utils/utils");

var languageManager = {};

(function(LanguageManager)
{
  var localeBasePath = "/assets/localization/";
  var locale = null;
  var localeMap = null;

  LanguageManager.init = function(callback, defaultLocale)
  {
    locale = localStorage.getItem("locale");
    if(locale === null)
    {
      locale = (typeof defaultLocale !== "undefined") ? defaultLocale : "nl-BE";
      localStorage.setItem("locale", locale);
    }

    var tmpLocale = utils.getQueryParam("locale");
    if(typeof tmpLocale !== "undefined" && tmpLocale !== null && tmpLocale !== "")
    {
      locale = tmpLocale;
      localStorage.setItem("locale", locale);
    }

    $("html").addClass(locale);

    getLocaleJSON(function()
    {
      _init(callback);
    }, function()
    {
      var html = $("html");
      html.removeClass(locale);
      locale = (typeof defaultLocale !== "undefined") ? defaultLocale : "nl-BE";
      html.addClass(locale);
      console.log("locale not found, switching to default [%s]", locale);
      localStorage.setItem("locale", locale);
      getLocaleJSON(function()
      {
        _init(callback)
      });
    });
  };

  function _init(callback)
  {
    applyLocale();
    $(".page-wrapper").show();

    if(LanguageManager.onInit !== null && typeof LanguageManager.onInit === "function")
    {
      LanguageManager.onInit();
    }

    if(LanguageManager.onInitGlobal !== null && typeof LanguageManager.onInitGlobal === "function")
    {
      LanguageManager.onInitGlobal();
    }

    if(typeof callback === "function")
    {
      callback();
    }
  }

  LanguageManager.onInit = null;

  LanguageManager.onInitGlobal = null;

  LanguageManager.changeLocale = function(newLocale)
  {
    $("html").removeClass(locale).addClass(newLocale);
    locale = newLocale;
    localStorage.setItem("locale", locale);
    LanguageManager.localize();
  };

  LanguageManager.getCurrentLocale = function()
  {
      return locale;
  };

  LanguageManager.localize = function()
  {
    if(!localeMapIsDefined() || locale !== localeMap.locale)
    {
      getLocaleJSON(function()
      {
        applyLocale();
      });
    }
    else
    {
      applyLocale();
    }
  };

  LanguageManager.applyLocaleOnHTML = function()
  {
    applyLocale();
  };

  function getLocaleJSON(callback, failCb)
  {
    var req = require.context("Localization", true, /\.json$/);

    try
    {
      var localeRequire = "./" + locale + ".json";

      if($.inArray(localeRequire, req.keys()) !== -1)
      {
        localeMap = req(localeRequire);

        if(typeof callback === "function")
        {
          callback();
        }
      }
      else if(typeof failCb === "function")
      {
        failCb();
      }
      else if(locale !== "nl-BE")
      {
        $("html").removeClass(locale).addClass("nl-BE");
        locale = "nl-BE";
        localStorage.setItem("locale", locale);
        getLocaleJSON(callback);
      }
      else
      {
        alert("Localisation could not be loaded, contact your site administrator.");
      }
    }
    catch(e)
    {
      console.error(e);
    }
  }

  function applyLocale()
  {
    $("[data-localize]").each(function()
    {
      var element = $(this);
      var key = $(this).data("localize");

      if(typeof localeMap === "object" && localeMap.localization.hasOwnProperty(key))
      {
        changeTextOrPlaceholder(element, localeMap.localization[key]);
      }
      else
      {
        changeTextOrPlaceholder(element, key);
      }
    });
  }

  function changeTextOrPlaceholder(element, text)
  {
    if(element.is("input") || element.is("textarea"))
    {
      //element.attr("placeholder", text.toLowerCase());
      element.attr("placeholder", text);
    }
    else
    {
      replaceNodeText(element, text);
    }
  }

  function replaceNodeText(element, text)
  {
    element.html(text);
  }

  LanguageManager.getValueForKey = function(key)
  {
    if(localeMapIsDefined() && localeMap.localization.hasOwnProperty(key))
    {
      return localeMap.localization[key];
    }
    else
    {
      return key;
    }
  };

  LanguageManager.hasKey = function(key)
  {
    return localeMapIsDefined() && localeMap.localization.hasOwnProperty(key);
  };

  function localeMapIsDefined()
  {
    return utils.isNotNull(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
  }
}(languageManager));

module.exports = languageManager;



// WEBPACK FOOTER //
// ./app/js/services/languagemanager.js